import type { DaySummary } from "../lib/api";

type Props = {
  days: DaySummary[];
};

function sum(items: DaySummary[], key: "calories" | "protein_g"): number {
  return items.reduce((s, d) => s + d[key], 0);
}

export function StatChips({ days }: Props) {
  const withData = days.filter((d) => d.meals > 0);
  const avgCal = withData.length ? Math.round(sum(withData, "calories") / withData.length) : 0;
  const avgProtein = withData.length
    ? +(sum(withData, "protein_g") / withData.length).toFixed(1)
    : 0;
  const mealsLogged = days.reduce((s, d) => s + d.meals, 0);
  const daysLogged = withData.length;

  return (
    <div className="stat-chips">
      <Chip value={avgCal} label="avg cal / day" color="var(--accent-cal)" />
      <Chip value={`${avgProtein}g`} label="avg protein / day" color="var(--accent-pro)" />
      <Chip value={mealsLogged} label="meals logged" color="var(--text)" />
      <Chip value={`${daysLogged} / 30`} label="days logged" color="var(--muted)" />
    </div>
  );
}

function Chip({
  value,
  label,
  color,
}: {
  value: string | number;
  label: string;
  color: string;
}) {
  return (
    <div className="stat-chip">
      <div className="stat-chip__value" style={{ color }}>
        {value}
      </div>
      <div className="stat-chip__label">{label}</div>
    </div>
  );
}
